import { useEffect } from "react";
import "../../assets/volunteers.css";
import eventLogo from "../../assets/eventLogo.png";
import pumpkin from "../../assets/pumpkin.svg";
import { fmt } from "../../lib/utils/time";
import { volunteerStatus } from "../../lib/services/authService";
import { logout } from "../../lib/services/authService";
import { useNavigate } from "react-router-dom";

export default function VolunteerComplete({
  isVolunteerAuthenticated,
  setIsVolunteerAuthenticated,
  setStencilData,
  stencilData,
  setTime,
  time,
}) {
  useEffect(() => {
    const checkVolunteerStatus = async () => {
      const response = await volunteerStatus();
      if (response.ok) {
        const data = await response.json();
        setIsVolunteerAuthenticated(data.isAuthenticated);
      }
    };

    checkVolunteerStatus();
  }, []);

  const navigate = useNavigate();

  const endSession = async () => {
    if (isVolunteerAuthenticated) {
      const response = await logout();
      if (response.ok) {
        setIsVolunteerAuthenticated(false);
        localStorage.clear();
        sessionStorage.clear();
        navigate("/volunteer/landing");
      } else {
        alert("Failed to logout");
      }
    }
  };

  function logAnother() {
    setStencilData(null);
    setTime(0);
    navigate("/volunteer/stencil-info");
  }

  return (
    <div className="vol-wrap">
      <div className="vol-stack">
        {/* Brand logo above the card */}
        <img
          src={eventLogo}
          alt="Spirits in the Gardens"
          className="vol-logo"
          loading="eager"
        />

        <div className="vol-card">
          <h3 className="vol-title">
            Please make sure the stencil code is written on the back.
          </h3>
          {stencilData && (
            <p className="vol-subtle">
              {stencilData.stencil.name} (ID: {stencilData.stencil.id}) · Time:{" "}
              <b>{fmt(time)}</b>
            </p>
          )}
          <img src={pumpkin} alt="" aria-hidden="true" className="vol-illust" />
        </div>

        {/* BUTTONS OUTSIDE THE CARD */}
        <div className={`vol-actions-outside grid-2`}>
          <button className="vol-btn primary" onClick={logAnother}>
            Log Another Pumpkin
          </button>
          <button className="vol-btn ghost" onClick={endSession}>
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
